<template>
    <div id="app" class="admin-page">
        <vue-progress-bar></vue-progress-bar>
        <admin-container
            :admin-name="adminName"
            :all-data-ready="allDataReady"
            :login-user="loginUser"
            :aside-menu-list="asideMenuList"
            :aside-menu-active="asideMenuActive"
            :aside-menu-openeds="asideMenuOpeneds"
            :aside-menu-class="asideMenuClass"
            :aside-popper-menu-class="asidePopperMenuClass"
            :page-loading-timeout="pageLoadingTimeout"
            @logout="handleLogout"
            @aside-menu-selected="onAsideMenuSelected"
            @cancelAccount="onCancelAccount"
        >
            <!-- 路由视图页面 -->
            <router-view></router-view>
        </admin-container>
    </div>
</template>

<script>
import AdminContainer from './admin-container';
import {
    defaultApiErrorHandler,
    PLATFORM_API,
    LOGOUT_API_URL,
    CANCEL_API_URL
} from '@/api.js';
import {
    ADMIN_ALL_DATA_LOADING_TIMEOUT,
    ADMIN_INDEX_URL,
    ADMIN_LOGIN_URL
} from '@/constants.js';
import {
    getVueInstanceByRef,
    findMenuByViewName,
    findMenuByMenuPath
} from '@/utils.js';

export default {
    name: 'AdminApp',
    components: {
        AdminContainer
    },
    data() {
        return {
            //adminName: 'XAdmin Pro',
            adminName: '机动车综合服务平台',
            allDataReady: false,
            pageLoadingTimeout: 2000,
            asideMenuList: [],
            asideMenuActive: '',
            asideMenuOpeneds: [],
            asideMenuClass: 'el-menu-vertical-dark admin-aside-menu',
            asidePopperMenuClass: 'el-menu-vertical-dark admin-aside-menu'
        };
    },
    computed: {
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        userNavMenuList() {
            return this.$store.state.loginUserAllData.userNavMenuList;
        }
    },
    methods: {
        afterAllDataLoaded() {
            this.prepareNavMenus();
            let menuPath = window.location.pathname;
            let selectedMenu = findMenuByMenuPath(
                this.userNavMenuList,
                menuPath
            );
            this.renderAdminView(
                selectedMenu ? selectedMenu.menuViewName : null,
                false
            );
            //console.log(`asideMenuActive = ${this.asideMenuActive}`);
            this.allDataReady = true; //通知全部数据加载已完毕
        },
        /**
         * 渲染指定viewName的视图
         * @param viewName          - 目标URL
         * @param forceSelectMenu   - 强制更新顶部导航菜单及侧边导航菜单的选中状态
         */
        renderAdminView(viewName, forceSelectMenu) {
            if (!viewName || viewName == 'Index') {
                this.applyDefaultSelects(forceSelectMenu);
            } else {
                let activeAsideMenu = findMenuByViewName(
                    this.userNavMenuList,
                    viewName
                );
                if (activeAsideMenu) {
                    this.asideMenuList = this.userNavMenuList[0].subMenuList;
                    this.asideMenuActive = activeAsideMenu.menuPath;
                    if (forceSelectMenu) {
                        this.forceUpdateAdminAsideMenuActive();
                    }
                } else {
                    this.applyDefaultSelects(forceSelectMenu);
                }
            }
            this.renderAsideMenuExpands();
        },
        /**
         * 应用默认的选中菜单
         */
        applyDefaultSelects(forceSelectMenu) {
            if (this.userNavMenuList[0]) {
                this.asideMenuList = this.userNavMenuList[0].subMenuList;
                this.asideMenuActive =
                    Array.isArray(this.asideMenuList) &&
                    this.asideMenuList.length
                        ? this.asideMenuList[0].menuPath
                        : '';
                if (forceSelectMenu) {
                    this.forceUpdateAdminAsideMenuActive();
                }
            } else {
                let indexMenu = this.defaultIndexMenu('');
                this.asideMenuList = [indexMenu];
                this.asideMenuActive = indexMenu.menuPath;
            }
        },
        /**
         * 强制选中侧边菜单的当前asideMenuActive
         */
        forceUpdateAdminAsideMenuActive() {
            let adminAsideMenu = getVueInstanceByRef(
                this.$root,
                'adminAsideMenu'
            );
            if (adminAsideMenu) {
                adminAsideMenu.updateActiveIndex(this.asideMenuActive);
            }
        },
        /**
         * 预处理userNavMenuList
         */
        prepareNavMenus() {
            //为每个NAV菜单的侧边菜单添加首页(Index)
            this.userNavMenuList.forEach(menu => {
                if (!menu.subMenuList) {
                    menu.subMenuList = [];
                }
                menu.subMenuList.unshift(this.defaultIndexMenu(menu.menuId));
            });
        },
        /**
         * 默认的首页菜单节点
         */
        defaultIndexMenu(parentMenuId) {
            return {
                menuId: 0,
                menuName: '首页',
                menuViewName: 'Index',
                menuType: 0,
                menuUrl: ADMIN_INDEX_URL,
                menuIcon: 'fas fa-home',
                menuIconSize: null,
                menuLevel: 1,
                menuPath: ADMIN_INDEX_URL,
                parentMenuId: parentMenuId,
                subMenuList: []
            };
        },
        /**
         * 渲染侧边菜单的展开情况
         */
        renderAsideMenuExpands() {
            //展开前三个侧边菜单
            let openedPaths = [];
            let count = 3;
            this.asideMenuList.forEach(menu => {
                if (
                    menu.subMenuList &&
                    menu.subMenuList.length &&
                    count-- > 0
                ) {
                    openedPaths.push(menu.menuPath);
                }
            });
            this.asideMenuOpeneds = openedPaths;
        },
        /**
         * 侧边菜单的选中事件
         */
        onAsideMenuSelected(index, indexPath) {},
        /**
         * 处理登出系统
         */
        handleLogout() {
            this.$confirm('您是否要退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post(PLATFORM_API.of(LOGOUT_API_URL))
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.resetStore(); //reset vuex store
                            window.location.href = ADMIN_LOGIN_URL;
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler)
                    .then(() => {
                        this.submiting = false;
                    });
            });
        },
        resetStore() {
            this.$store.dispatch('resetStore4Logout');
        },
        onCancelAccount() {
            this.$confirm(
                '注销后账号停止服务，依法律法规、监管规定必须留存的业务档案、操作日志按法定期限留存，其余个人信息在法定期限届满后删除。您确定要注销账号吗?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                this.$http
                    .post(PLATFORM_API.of(CANCEL_API_URL))
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.$message.success('您的账号已注销！');
                            this.resetStore(); //reset vuex store
                            window.location.href = ADMIN_LOGIN_URL;
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler)
                    .then(() => {
                        this.submiting = false;
                    });
            });
        }
    },
    watch: {
        '$store.state.loginUserAllDataReady': function(newVal, oldVal) {
            if (newVal) {
                let timeout =
                    ADMIN_ALL_DATA_LOADING_TIMEOUT - this.allAdminDataLoadTimes;
                if (timeout > 0) {
                    setTimeout(() => {
                        this.afterAllDataLoaded();
                    }, timeout);
                } else {
                    this.afterAllDataLoaded();
                }
            }
        }
    }
};
</script>

<style lang="scss"></style>
